// @flow
import typeToReducer from 'type-to-reducer'

import type { Region } from '@alphaott/api-client/types/regions'

import { FETCH_REGIONS_TYPE } from '../../actions/appRegions'

export type RegionsState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: Array<Region>,
}

const initialState: RegionsState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: [],
}

const regions = typeToReducer(
  {
    [FETCH_REGIONS_TYPE]: {
      LOADING: (state): RegionsState => ({
        ...state,
        errors: [],
        data: [],
        isLoading: true,
      }),

      SUCCESS: (state, action): RegionsState => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        errors: [],
        data: action.payload.data,
      }),

      ERROR: (state, action): RegionsState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
        data: [],
      }),
    },
  },
  initialState,
)
export { regions }
